/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ISchemaDynamicModel, TGenericBlueprintSchema } from "@adapptio/lib-blueprint";
import { mapperDescriptor } from "../../modules/Core/ReferenceGuide/mappers/mapperDescriptor";
import { mapperExamples } from "../../modules/Core/ReferenceGuide/mappers/mapperExamples";
import { INSPECTOR_NODE_TYPE, TInspectorNode } from "../InspectorNodeTypes";
import { mapModelToNodes } from "../mapModelToNodes";
import { getParentComponentName } from "../utils";

export function dynamicMapper(model: ISchemaDynamicModel<unknown, TGenericBlueprintSchema>): TInspectorNode {
	if (!model?.value) {
		return;
	}

	const valueNode = mapModelToNodes(model.value);

	return {
		type: INSPECTOR_NODE_TYPE.DEFAULT,
		key: `${model.nodeId}`,
		label: "",
		tooltip: "",
		default: model.schema.opts["default"] || null,
		options: model.schema.opts["options"],
		required: model.schema.opts["constraints"]?.required || false,
		referenceData: getParentComponentName(model),
		descriptor: mapperDescriptor(model.schema),
		examples: mapperExamples(model.schema),
		deps: [ model, ...valueNode.deps ],
		controls: [],
		children: [ () => mapModelToNodes(model?.value) ]
	};
}
